import { Component, OnInit, ChangeDetectionStrategy, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { LgvUserService } from '../../core/services/lgv-user.service';
import { environment as env } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from '../../core/notifications/notification.service';

@Component({
    selector: 'lus-confirm-login-link-modal',
    templateUrl: './confirm-login-link-modal.component.html',
    styleUrls: ['./confirm-login-link-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmEmailLoginLinkModalComponent implements OnInit, OnDestroy {
    IsLoading: boolean = false;
    IsLoading$ = new BehaviorSubject(this.IsLoading);

    sendOption: any = "BCC";
    options: any[] = [{ value: 'BCC', title: "BCC Me" }, { value: 'CC', title: "CC Me" }, { value: null, title: "Don't include me" }];
    onDestroy$ = new Subject();

    constructor(
        private http: HttpClient,
        public LgvUserSvc: LgvUserService,
        private NotificationSvc: NotificationService,
        public dialogRef: MatDialogRef<ConfirmEmailLoginLinkModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    OnCancel(): void {
        this.dialogRef.close({ action: false });
    }

    OnSend() {
        this.IsLoading$.next(true);
        let param = this.sendOption ? `?copyType=${this.sendOption}` : '';
        let bldUrl = `${env.LgvApiBaseUrl}/clients/${this.data.content.clientId}/email/login${param}`;

        this.http.post<any>(bldUrl, {}).pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.NotificationSvc.success(`Send Client Login Link!`);
            this.IsLoading$.next(false);
            this.dialogRef.close({ action: true });
        },
            err => {
                this.NotificationSvc.error(`There was an error trying to email the login link.`);
                this.IsLoading$.next(false);
            })
    }

}
